import styled, { css } from 'styled-components';
import DataTable from '@components/DataTable';
import { media } from '@simplywallst/ui-core';

export const TooltipName = styled('span')`
  border-bottom: 1px dotted ${(props) => props.theme.color.brand01};
  cursor: help;
  width: fit-content;
`;

export const TipContainer = styled('span')`
  display: block;
  max-width: 200px;
`;
const ColStyle = css`
  padding: ${({ theme }) => theme.x1spacePx}px 12px;
  text-align: right;
  &:first-child {
    text-align: left;
  }
`;

export const TableWrapper = styled('div')`
  width: max-content;
  ${media.lgUp`
    width: 100%;
  `}
`;
export const AnalystDataTable = styled(DataTable)`
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  thead tr th {
    ${({ theme }) => theme.typography.tinyStrong};
    height: ${({ theme }) => theme.x4spacePx}px;
    background: ${({ theme }) => theme.color.darkerGray};
  }
  th {
    position: sticky;
    top: 0px;
    z-index: 1;
    ${ColStyle}
  }
  td {
    white-space: nowrap;
    vertical-align: middle;
    ${ColStyle}
  }

  caption {
    text-align: left;
  }
`;

export const TextColor = styled('span')<{ color: string }>`
  color: ${({ color }) => color};
`;
